
import React, { useState, useEffect } from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  CardTitle,
  CardText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import useGlobal from "store";


// core components
import bgImage from "assets/img/stats4.jpg";
import { Link } from "react-router-dom";

const OnboardingPage = (props) => {

    const [onboardingState] = useGlobal(
        state => state.onboarding
    );

    useEffect(() => {
        console.log('onboarding state', onboardingState);
    }, [onboardingState]);


  //const [formState, setFormState] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModalOpen = () => {
    setModalOpen(!modalOpen);
  }
  /*
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let formFields = { ...formState };
    formFields[name] = value;
    setFormState(formFields);
  }

  const submitForm = async (event) => {
    console.log('submit form');
    event.preventDefault();
    const justFormData = new FormData(event.target);
    var object = {};
    justFormData.forEach((value, key) => {object[key] = value});
    const formData = { ...formState };
    console.log('FORM DATA', formData);


    //actions.authActions.getAuthToken(formData);
  }*/

  /*eslint no-multi-str: "error"*/
  const codeSnippet = "<script>\n"+
    "window.streempaySettings = {\n"+
    "  app_id: '329483932093'\n"+
    "};\n"+
    "(function(i,s,o,g,r,a,m){i['StreemPayObject']=r;i[r]=i[r]||function(){\n"+
      "(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n"+
      "m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n"+
      "})(window,document,'script','https://business.streempay.com/widget.js','stpay');\n"+
  "</script>";

  return ( 
    <>
        <div className="content">
          <div className="">
            <Container className="onboarding-page">
                <Card className="text-center">
                    <CardHeader>
                      { onboardingState.basic_complete 
                          ? <i className={"now-ui-icons ui-1_check"}></i> 
                          : <i className={"now-ui-icons users_single-02"}></i> }
                    </CardHeader>
                    <CardBody>
                        <CardTitle>Basic Info</CardTitle>
                        <CardText>Let's get you all set up with your account.</CardText>
                        <Link to={"/onboarding/basic"} className="btn btn-primary">Start</Link>
                    </CardBody>
                </Card>
                <Card className="text-center">
                    <CardHeader>
                      { onboardingState.business_complete 
                          ? <i className={"now-ui-icons ui-1_check"}></i> 
                          : <i className={"now-ui-icons business_briefcase-24"}></i> }
                    </CardHeader>
                    <CardBody>
                        <CardTitle>Business Details</CardTitle>
                        <CardText>Add a few data points to tailor your account to your business.</CardText>
                        <Link to={"/onboarding/business"} className="btn btn-primary" disabled={!onboardingState.basic_complete}>Start</Link>
                    </CardBody>
                </Card>
                <Card className="text-center">
                    <CardHeader>
                      { onboardingState.installation_complete 
                          ? <i className={"now-ui-icons ui-1_check"}></i> 
                          : <i className={"now-ui-icons ui-2_settings-90"}></i> }
                    </CardHeader>
                    <CardBody>
                        <CardTitle>Installation</CardTitle>
                        <CardText>Your bespoke installation javascript snippet.</CardText>
                        <Button color="primary" onClick={toggleModalOpen} disabled={!onboardingState.basic_complete && onboardingState.business_complete}>Get Code</Button>
                    </CardBody>
                </Card>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + bgImage + ")" }}
        />
        <Modal isOpen={modalOpen} toggle={toggleModalOpen}>
            <ModalHeader className="justify-content-center" toggle={toggleModalOpen}>
                StreemPay Script
            </ModalHeader>
            <ModalBody>
                Place this script just above the closing <code>body</code> tag.
                <pre>
                  <code>{codeSnippet}</code>
                </pre>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleModalOpen}>
                    Got it
                </Button>
            </ModalFooter>
        </Modal>
      </>
    );
}

export default OnboardingPage;
